export default "__VITE_ASSET__d67d5618__"